import PropTypes from 'prop-types';

import { numberFormat } from '@/utils/unitUtils';

const ChartBars = ({ colors, barPositions, hasNegativeValues, zeroLinePosition, unitString }) => (
  <div className="flex items-center h-8 mb-4">
    <div className="relative h-full rounded-2xl overflow-hidden w-full">
      {hasNegativeValues && (
        <div className="absolute top-0 bottom-0 w-px bg-gray-400 z-10" style={{ left: `${zeroLinePosition}%` }} />
      )}

      {barPositions.map((item, i) => {
        const color = colors[i % colors.length];
        const formattedValue = numberFormat(item.value, 2);
        const title =
          hasNegativeValues && item.isNegative
            ? `${item.label}: ${formattedValue} ${unitString} (Carbon Removal)`
            : `${item.label}: ${formattedValue} ${unitString}`;

        return (
          <div
            key={`${item.isNegative ? 'negative' : 'positive'}-${item.label}-${i}`}
            className={`absolute h-full ${color} transition-all duration-500 hover:opacity-80 ${
              item.isNegative ? 'border border-green-300' : ''
            }`}
            style={{ left: `${item.left}%`, width: `${item.width}%` }}
            title={title}
          />
        );
      })}
    </div>
  </div>
);

ChartBars.propTypes = {
  colors: PropTypes.array.isRequired,
  barPositions: PropTypes.array.isRequired,
  hasNegativeValues: PropTypes.bool.isRequired,
  zeroLinePosition: PropTypes.number.isRequired,
  unitString: PropTypes.string.isRequired,
};

export default ChartBars;
